import React, { Dispatch, FC } from 'react';

import { useI18n } from 'i18n';
import { ISelectOption } from 'types/select';
import { PAGE_SIZES } from 'constants/table';
import { OnPageChangeType } from 'types/pagination';
import { Select } from 'components/molecules/select';
import { Pagination } from 'components/molecules/pagination';

import styles from './styles.module.css';

interface ITableFooterProps {
  totalCount: number;
  pageSize: ISelectOption<number> | null;
  onPageChange: OnPageChangeType;
  updatePageSize: Dispatch<ISelectOption<number>>;
  page: number;
}

export const TableFooter: FC<ITableFooterProps> = (props) => {
  const { totalCount, pageSize, onPageChange, updatePageSize, page } = props;

  const { fc } = useI18n();

  return (
    <div className={styles.wrapper}>
      <div className={styles.controls}>
        <Pagination pageSize={pageSize?.value || 1} totalCount={totalCount} onPageChange={onPageChange} page={page} />
        <div className={styles.select}>
          <Select rounded selectedValue={pageSize} options={PAGE_SIZES} onOptionChange={updatePageSize} />
        </div>
      </div>
      <div className={styles.text}>{`${fc('totalNoOfEntries')} : ${totalCount}`}</div>
    </div>
  );
};
